module.exports = __webpack_public_path__ + "img/products_big_can_pomegranate.e5d096c2.png";